import { QueryResponse } from 'api/queries/activityCodesByVersion.query';

export const mapper = (item: QueryResponse): { value: number; label: string } => {
    const label = item.alias
        ? `${item.alias}: ${item.description}`
        : `${item.scope}: ${item.typeName}: ${item.description}`;
    return {
        value: item.uid,
        label,
    };
};
